<div class="dashboard">
	<app-header></app-header>
	<div class="container">
		<router-outlet></router-outlet>
		<app-footer></app-footer>
	</div>
</div>